import React from "react";
import styles from "./CardWrapper.module.scss";
import classNames from "classnames";

interface Props {
  className?: string;
  center?: boolean;
  noScroll?: boolean;
  direction?: "ltr" | "rtl";
  title?: string;
}

const CardWrapper: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div
      className={classNames(styles.CardWrapper, {
        [styles.center]: props.center,
      })}
      style={{
        overflowY: props.noScroll ? "unset" : "auto",
        direction: props.direction || "rtl",
      }}
    >
      <div className={classNames(styles.Card, props.className)}>
        {props.title && <div className={styles.Header}>{props.title}</div>}
        {props.children}
      </div>
    </div>
  );
};

export default CardWrapper;
